const captchaForms = document.querySelectorAll(".captcha-form");

if (captchaForms.length) {
    global.reCaptchaOnloadCallback = function () {
        captchaForms.forEach(function (captchaForm) {
            captchaForm.dataset.captchaId = grecaptcha.render(
                captchaForm.querySelector(".captcha-placeholder"),
                {
                    action: captchaForm.dataset.captchaAction ?? null,
                    callback: function (response) {
                        captchaForm.querySelector("input.captcha-response").value = response;
                    },
                    expiredCallback: function (response) {
                        captchaForm.querySelector("input.captcha-response").value = null;
                    },
                    sitekey: captchaForm.dataset.captchaKey,
                    theme: "light",
                }
            );
        });
    };

    const script = document.createElement("script");

    script.async = true;
    script.defer = true;
    script.src   = "https://www.google.com/recaptcha/api.js?onload=reCaptchaOnloadCallback&render=explicit";
    script.type  = "text/javascript";

    document.body.appendChild(script);
}
